// imports for app window layout
import { useAuth0 } from '@auth0/auth0-react';
import MainWindow from '../../app_layout/main_window/MainWindow';
import ChatWindow from '../../app_layout/chat_window/ChatWindow';
import SideBar from '../../app_layout/sidebar/SideBar';
import APP_WINDOW_CONFIG from '../../app_layout/layout_config';

// imports relevant for HTTP calls
import DisplayException from '../../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import {SERVER_URL, WEBSOCKET_URL} from '../../config_server_url';

// import user session information
import UserSessionContext from '../../user_session/context_user_session';
import { SetSessionInfo_OnDeleteCurrentProject, SetSessionInfo_OnDeleteCurrentCampaign } from '../../user_session/session_info_utils';

// imports this module specific
import '../../css_styles/button_styles.css'
import classes from '../../current_campaign/campaign_setup/PageCampaignSetup.module.css';
import CSVInfoTable from '../../current_campaign/campaign_data/CSVInfoTable';
import WorkflowViewer from '../../experimental_setup/WorkflowViewer'
import DesignSpaceViewer from '../../design_space/DesignSpaceViewer'
import ObjectiveViewer from '../../objective/ObjectiveViewer'
import InfoPopup from '../../popup_windows/InfoPopup';
import CyclePrev from '../../current_campaign/optimization_cycles/CyclePrev'
import CycleNext from '../../current_campaign/optimization_cycles/CycleNext'


import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';



function PageProjectData() {

    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // This Component requires to fetches data on first load -> setIsloading(true);
    // This Component does not fetch data on first load -> setIsloading(false);
    const [isLoading, setIsLoading] = useState(false);

    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();
    const [broadcastProject, setBroadcastProject] = useState([]); //get session notifications via web sockets
    const [broadcastCampaign, setBroadcastCampaign] = useState([]); //get session notifications via web sockets

    // ------------------ Add User Session Websockets For Notification Events Across All Tenant (Workspace) Members -----------------------------

    useEffect(() => {
        // Create WebSocket connection`${SERVER_URL}/all_projects/load/`
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_project/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        // Connection opened
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
          };
        // Listen for messages
        ws.onmessage = (event) => {
        //   console.log('Message received:', event.data);
          let parser = event.data.split('__');
          let sender = parser[0]
          let type = parser[1].split('.')[1]
          let project_uuid = parser[2]
          if (type === 'ProjectDelete'){
            if(project_uuid === usr_session_ctx.session_info.uuid_current_project) {
                let new_broadcast = (<>{sender} has deleted <strong>your current project uuid:{project_uuid}</strong></>);
                usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentProject(usr_session_ctx);
                handleUpdateUserSession()
                setBroadcastProject(prevBroadcast => [...prevBroadcast, new_broadcast]);
            }
          }
        };
        // Connection closed
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
          ws.close();
        };
      }, []); // Effect runs when tenant_id or user_id changes

      useEffect(() => {
        const ws = new WebSocket(`${WEBSOCKET_URL}/user_session/ws_campaign/${usr_session_ctx.uuid_tenant}/${user.sub}`);
        ws.onopen = () => {
        //   console.log(`WebSocket connection established for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        ws.onerror = (error) => {
            // console.error("WebSocket error observed:", error);
        };
        // Listen for messages
        ws.onmessage = (event) => {
            console.log('Message received:', event.data);
            let parser = event.data.split('__');
            let sender = parser[0]
            let type = parser[1].split('.')[1]
            let project_uuid = parser[2]
            let campaign_uuid = parser[3]
            if (project_uuid === usr_session_ctx.session_info.uuid_current_project){
                if (type === 'UpdateCampaignTitle'){
                    let new_broadcast = (<>{sender} has updated the campaign title for campaign uuid:{campaign_uuid}.</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignCreate'){
                    let new_broadcast = (<>{sender} has created a new campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignDelete'){
                    if(campaign_uuid === usr_session_ctx.session_info.uuid_current_opt_campaign) {
                        let new_broadcast = (<>{sender} has deleted <strong>your current campaign uuid:{campaign_uuid}</strong></>);
                        usr_session_ctx.session_info = SetSessionInfo_OnDeleteCurrentCampaign(usr_session_ctx);
                        handleUpdateUserSession()
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    }
                    else{
                        let new_broadcast = (<>{sender} has deleted campaign uuid:{campaign_uuid}</>);
                        setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                    }
                }
                if (type === 'CampaignDataUpload'){
                    let new_broadcast = (<>{sender} has uploaded new data for campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
                if (type === 'CampaignDataRemoved'){
                    let new_broadcast = (<>{sender} has removed data from campaign uuid:{campaign_uuid}</>);
                    setBroadcastCampaign(prevBroadcast => [...prevBroadcast, new_broadcast]);
                }
            }
        };
        ws.onclose = () => {
        //   console.log(`WebSocket connection closed for tenant ${usr_session_ctx.uuid_tenant}, user ${user.sub}`);
        };
        // Clean up WebSocket connection when component unmounts
        return () => {
        ws.close();
        };
    }, []); // Effect runs when tenant_id or user_id changes





      function handleUpdateUserSession() {
        setIsLoading(true);
        let session_update = {key: 'session_info', value: usr_session_ctx.session_info}
        fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
                                                           headers:{'Content-Type':'application/json',
                                                                   'auth0_user': user.sub,
                                                                   'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                           body:JSON.stringify(session_update)
        })
        .then((res) => {
        if(!res.ok) {
            throw new Error(`HTTP error ${res.status}`);
        }
            return res.json();
        })
        .then((data) => {
            setIsLoading(false);
        })
            .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });
   }



    // ------------------ General Window Layout -----------------------------
    
    const [canvasSize, setCanvasSize] = useState({width: 0, height: 0});
    const [layout, setLayout] = useState({sidebar:0, main: 0, chat: 0});
    const [toggleSideBar, setToggleSideBar] = useState(false);

    useEffect(() => {
        function handleResize() {
            let window_height = window.innerHeight;
            let window_width = window.innerWidth;
            let canvas_height = window_height - APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = (window_width - sidebar)*APP_WINDOW_CONFIG.CHAT_WIDTH_RELATIVE;
            chat = Math.max (chat, APP_WINDOW_CONFIG.MIN_CHAT_WIDTH_PX);
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setCanvasSize({width: window_width, height: canvas_height});
            // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
            if(toggleSideBar){
                sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
                main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            }
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        // Set initial height
        handleResize();
        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);
        // Remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [toggleSideBar]); // Empty dependency array ensures the effect only runs once


    function handleToggle() {
        // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
        if(!toggleSideBar){
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        else
        {
            let window_width = window.innerWidth;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = layout.chat;
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        setToggleSideBar(!toggleSideBar);
    }

// ------------------ Side Bar Content -----------------------------

    let sidebar = (<>
        <SideBar width={layout.sidebar} 
                 toggle={toggleSideBar} 
                 handle_toggle={handleToggle} 
                 active_link='project_data' >
        </SideBar>
    </>)

// ------------------ Main Window Content ----------------------------

    const navigate = useNavigate();

    const [columnNames, setColumnNames] = useState([]);
    const [allCSVFilesAllCampaigns, setAllCSVFilesAllCampaigns] = useState([]);
    const [allCampaignInfo, setAllCampaignInfo] = useState([]);

    const [windowSelection, setWindowSelection] = useState('ExperimentalWorkflow');
    const [campaignObjects, setCampaignObjects] = useState(null);
    const [viewCampaignSetup, setViewCampaignSetup] = useState(false);

    const [numCampaigns, setNumCampaigns] = useState(1);
    const [existingCampaigns, setExistingCampaigns] = useState(false);
    const [campaignId, setCampaignId] = useState(-1);
    const [prevActive, setPrevActive] = useState(false);
    const [nextActive, setNextActive] = useState(false);

   

    function load_campaign_data(){
        if(usr_session_ctx.session_info.uuid_current_project !== ''){
            const uuid_project = usr_session_ctx.session_info.uuid_current_project;
            setIsLoading(true); // Set loading state to true when fetch begins    // server retunrs -> cols about what info is shown. 
            fetch(`${SERVER_URL}/current_project/load_all_campaign_data_info/`, {method: 'POST',
                                                                                      headers:{'Content-Type':'application/json',
                                                                                               'uuid_tenant': usr_session_ctx.uuid_tenant},
                                                                                      body:JSON.stringify(uuid_project)})
            .then((res) => {
                if(!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((loaded_info) => {
                setColumnNames(loaded_info.data.info_type);
                setAllCampaignInfo(loaded_info.data.all_campaign_info);
                setAllCSVFilesAllCampaigns(loaded_info.data.all_csv_info);
                let num_campaigns = loaded_info.data.all_csv_info.length
                if (num_campaigns === 0) {
                    setExistingCampaigns(false);
                    setCampaignId(-1);
                } else {
                    setCampaignId(0);
                    setExistingCampaigns(true);
                }
                setNumCampaigns(num_campaigns)
                // load the info_type -> goes as column names for the all_projets table
                setIsLoading(false); 
            })
            .catch((err) => {
                setException(true);
                setIsLoading(false);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }

    }
     // Fetch All Projects
    useEffect(() => {
        load_campaign_data()
    }, []);


    async function handleDownloadRawDataFile(event){
        let parser = event.target.id.split('_');
        let uuid_raw_data_file = parser[1];
        let csv_index = parseInt(parser[2]);
        let raw_data_file_id = parseInt(parser[3]);
        let campaign_id = parseInt(parser[4]);
        try{
            
            let headers = {
                'Content-Type': 'application/json',
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/download_raw_data_file/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(uuid_raw_data_file)
            });
            if(response.ok){
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', allCSVFilesAllCampaigns[campaign_id][csv_index].raw_data[raw_data_file_id].filename); // Change this if you want a different name for the downloaded file
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        } catch(err) {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }



    async function handleDownloadTrainingDataFile(event){
        let parser = event.target.id.split('_');
        let uuid_training_data_file = parser[1];
        let csv_index = parseInt(parser[2]);
        let training_data_file_id = parseInt(parser[3]);
        let campaign_id = parseInt(parser[4]);
        try{
            
            let headers = {
                'Content-Type': 'application/json',
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/download_training_data_file/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(uuid_training_data_file)
            });
            if(response.ok){
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `training_data_${allCSVFilesAllCampaigns[campaign_id][csv_index].training_data[training_data_file_id]}.csv`); // Change this if you want a different name for the downloaded file
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        } catch(err) {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }


    async function handleDownloadCSVData(event){
        let parser = event.target.id.split('_');
        let uuid_csv_data_file = parser[1];
        try{
            
            let headers = {
                'Content-Type': 'application/json',
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/download_csv_data_file/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(uuid_csv_data_file)
            });
            if(response.ok){
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `csv_data_${uuid_csv_data_file}.csv`); // Change this if you want a different name for the downloaded file
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        } catch(err) {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }


    async function handleViewCampaignSetup(event){
        let parser = event.target.id.split('_');
        let csv_id = parseInt(parser[1]);
        let uuid_experimental_setup = parser[2];
        let uuid_design_space = parser[3];
        let uuid_objective = parser[4];
        let campaign_id = parseInt(parser[5]);
        let campaign_objects={uuid_experimental_setup: uuid_experimental_setup,
                              uuid_design_space: uuid_design_space,
                              uuid_objective:uuid_objective,
                              uuid_csv: allCSVFilesAllCampaigns[campaign_id][csv_id].uuid,
                              data_origin: allCSVFilesAllCampaigns[campaign_id][csv_id].data_origin}
        setCampaignObjects(campaign_objects)
        setViewCampaignSetup(true)
    }


    let classEW = 'black';
    let classDS = 'black';
    let classO = 'black';

    let viewer = (<></>);

    if (windowSelection === 'ExperimentalWorkflow' && campaignObjects){
        classEW = 'selectionLink selected';
        classDS = 'selectionLink';
        classO = 'selectionLink';
        viewer=(<>
                <WorkflowViewer uuid_experimental_setup={campaignObjects.uuid_experimental_setup} 
                                width={layout.main} 
                                height={canvasSize.height-80} 
                                hideActionPanel={true}/>
            </>);
    }

    if (windowSelection === 'DesignSpace' && campaignObjects){
        classEW = 'selectionLink';
        classDS = 'selectionLink selected';
        classO = 'selectionLink';
        viewer=(<>
            <DesignSpaceViewer campaign_objects={campaignObjects}
                               width={layout.main}
                               height={canvasSize.height-80}
                               validated={true}
                               hideActionPanel={true}/>
        </>);
    }

    if (windowSelection === 'Objective' && campaignObjects){
        classEW = 'selectionLink';
        classDS = 'selectionLink';
        classO = 'selectionLink selected';
        viewer=(<>
            <ObjectiveViewer   campaign_objects={campaignObjects} 
                               width={layout.main}
                               height={canvasSize.height-80}
                               validated={true}
                               hideActionPanel={true}/>
        </>);
    }

    function selectWindowMode(event){
        event.preventDefault();
        setWindowSelection(event.target.id);
    }

    useEffect(() => {
        if (campaignId > 0) {setPrevActive(true);}
        else {setPrevActive(false);}
        if (campaignId < numCampaigns-1) {setNextActive(true);}
        else {setNextActive(false);}
    }, [campaignId, numCampaigns]);

    function handleNextCampaign(){
        setCampaignId(campaignId+1);
    }
   
    function handlePrevCampaign(){
        setCampaignId(campaignId-1);
    }

    let cycleNav = (<></>);
    if(numCampaigns > 0) {
        cycleNav = (<>
            <div style = {{'marginTop': '20px', 'marginBottom': '0px', 'border':'none', 'outline':'none', 'padding':'0px', display:'flex', alignItems:'center',
                     'fontSize': '24px', 'fontWeight':'bold', position: 'relative', left:'3%', width:'94%'}} >
                <CyclePrev handleClick={handlePrevCampaign} active={prevActive}/>   
                    <div style={{margin:'0px', marginRight:'9px'}}>Campaign {campaignId+1} of {numCampaigns}</div>
                <CycleNext handleClick={handleNextCampaign} active={nextActive}/>
            </div>
        </>);
    }

    let mainWindow = (<></>);


    if (!isLoading && !Exception && existingCampaigns && !viewCampaignSetup && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 

        const displayCSVInfo = (
            <div >
                <h3 style={{ marginLeft: '0px', marginBottom: '0px', marginTop: '20px', position: 'relative', left: '3%' }}>
                    Campaign Title: {allCampaignInfo[campaignId].title}
                </h3>
                <p style={{ position: 'relative', left: '3%', marginTop: '3px', marginBottom: '0px', fontSize: '14px' }}>
                    Campaign UUID: {allCampaignInfo[campaignId].uuid}
                </p>
                <div style={{ position: 'relative', left: '3%', width: '94%', paddingTop: '10px', height: 'fit-content', overflow: 'auto' }}>
                    <CSVInfoTable 
                        campaign_id={campaignId}
                        colNames={columnNames} 
                        tableRows={allCSVFilesAllCampaigns[campaignId]}
                        itemsPerPage={3}
                        downloadCSVData={handleDownloadCSVData}
                        downloadRawDataFile={handleDownloadRawDataFile}
                        viewCampaignSetup={handleViewCampaignSetup}
                        downloadTrainingDataFile={handleDownloadTrainingDataFile}
                    />
                </div>
            </div>
        );

        mainWindow = (<>
             <MainWindow width={layout.main} >
             <h2 style={{ marginLeft: '0px', marginBottom: '0px', marginTop: '20px', position: 'relative', left: '3%' }} >
                    Project Data of All Campaigns
                </h2>
             {cycleNav}
                {displayCSVInfo}
             </MainWindow>
         </>);

    }

    if (!isLoading && !Exception && existingCampaigns && viewCampaignSetup && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        // Regular Content and Logic of Main Window Goes Here
        mainWindow = (<></>);
        // else {
            mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%'}}>
                <h3 style={{marginTop:'10px',marginBottom:'10px'}}>Origin of CSV Data (uuid: {campaignObjects.uuid_csv})</h3>
                <p style={{fontWeight:'bold', marginTop:'0px', marginBottom:'0px', fontSize:'16px'}}>Uploaded at Campaign:</p>
                <p style={{marginTop:'3px', marginBottom:'0px', fontSize:'14px'}}>Campaign Title: {campaignObjects.data_origin.campaign_title}</p>
                <p style={{marginTop:'3px', marginBottom:'0px', fontSize:'14px'}}>Campaign UUID: {campaignObjects.data_origin.uuid_opt_campaign}</p>
                <p style={{marginTop:'3px', marginBottom:'0px', fontSize:'14px'}}>Cycle: {campaignObjects.data_origin.cycle_idx + 1}</p>
            </div>
            <div style={{position:'relative', left:'5%', top:'12px', display:'flex', gap:'10px', marginTop:'5px', zIndex:'100', width:'fit-content'}}>        
                    <button id='ExperimentalWorkflow' className={classEW} onClick={selectWindowMode} >Experimental Workflow</button>
                    <button id='DesignSpace' className={classDS} onClick={selectWindowMode}>Design Space</button>
                    <button id='Objective'className={classO} onClick={selectWindowMode}>Objective</button>
                </div>     
                <div className = {classes.inner_canvas} style={{height:canvasSize.height-160, paddingTop:'20px'}}>
                    {viewer}
                </div>
                <div style={{ position: 'relative', display: 'flex', marginLeft: '3%', marginTop: '18px', marginBottom: '18px', height: 'fit-content', width: 'fit-content' }}>
                        <button className={'actionButtonSmall'} style={{ width: '70px', left: '3%' }} onClick={()=>{ setCampaignObjects(null);
                                                                                                                     setViewCampaignSetup(false);}}>
                        Exit</button> 
                </div>
            </MainWindow>
        </>);
        // }
    }

    if (!isLoading && !Exception && !existingCampaigns && broadcastProject.length === 0 && broadcastCampaign.length === 0) { 
        mainWindow = (<>
            <MainWindow width={layout.main} >
                <div style={{fontSize:'18px', position:'relative', textAlign:'center', height:'fit-content', marginTop:'50px', width:'100%'}} >
                The project does not yet contain any optimization campaign.
                </div>               
            </MainWindow>
        </>);
    }

    if (!isLoading && !Exception && broadcastCampaign.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastCampaign(prevBroadcast => []); load_campaign_data();} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastCampaign.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }
    
    if (!isLoading && !Exception && broadcastProject.length > 0){
        mainWindow = (<>
            <MainWindow width={layout.main} >
            <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                <InfoPopup ypos={'60px'} handleOk={()=>{setBroadcastProject(prevBroadcast => []); navigate('/')} } >
                    <div style={{fontWeight:'bold', textAlign:'left'}}>Session has been updated by another user:</div>
                    <ul style={{ listStyleType: 'disc', paddingLeft: '20px', textAlign: 'left' }}>
                        {broadcastProject.map((item, index) => (
                        <li key={index}>{item}</li>
                        ))}
                    </ul>
                </InfoPopup>
                </div>
            </MainWindow>
            </>);
    }


    if (isLoading && !Exception) {   
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </MainWindow>
            </>);
       }

    if(Exception){
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </MainWindow>
            </>);
    }


// ------------------ Return All Components ----------------------------

    // Show Sidebar, MainWindow and ChatWindow
    return(
        <>
        <div style={{position:'relative', display:'grid', gridTemplateColumns: 'auto auto auto', overflow: 'hidden', left:`${APP_WINDOW_CONFIG.OFFSET_WINDOW_LEFT_PX}px`, top:`${APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX}px`, height:canvasSize.height, width:'100%'}}>
            {sidebar}
            {mainWindow}
            <ChatWindow width={layout.chat}/>
        </div>    
        </>
    );

}


export default PageProjectData;


